import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const imageOptimizationApi = process.env.NEXT_PUBLIC_IMAGE_LOADER_URL;
export const CDN_URL = imageOptimizationApi + "/" + process.env.NEXT_PUBLIC_CDN_URL + "/"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const parseHtml = (str: string) => {
  if (!str) {
    return "";
  }

  const addIdToHeading = (match: string, p1: string) => {
    return `<${p1}>`;
  };

  const addIdToStrong = (match: string, p1: string) => {
    return `<strong id="${p1}">`;
  };

  return str
    .replaceAll(/&lt;strong&gt;/g, addIdToStrong)
    .replaceAll(/&lt;\/strong&gt;/g, "</strong>")
    .replaceAll(/&lt;(h[1-6])&gt;/g, addIdToHeading)
    .replaceAll(/&lt;\/(h[1-6])&gt;/g, "</$1>")
    .replaceAll(/&lt;/g, "<")
    .replaceAll(/&gt;/g, ">")
    .replaceAll(/&amp;/g, "&")
    .replaceAll(/&quot;/g, '"')
    .replaceAll(/&#039;/g, "'");
};


export const firstCharUpper = (str: string) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
